





















































































































































































































































































































































import { Component, Prop, Vue } from "vue-property-decorator";
//import * as admin from 'firebase-admin';
//import { firestore } from 'firebase';
import firebase from 'firebase/app'

interface Post {
  uid: string
  title: string
  content: string
  createdAt: string
  tags: Array<string>
  image: string
}
interface Description {
  id: string;
  title: string;
  descriptions: Array<Td>;
}
interface Td {
  id: string;
  title: string;
  images: Array<Image>;
  items: Array<string>;
  pres: Array<Pre>;
}

interface Image {
  src: string;
  comment: string;
}
interface Pre {
  src: string;
  comment: string;
}

interface AddDocument {
	id: string;
	product: AddProduct;
}
interface UpdateDocument {
	id: string;
	product: UpdateProduct;
}
interface AddProduct {
	name: string;
	price: number;
	description: string;
	photoURL: string;
	createdAt: any;
	updatedAt: any;
}
interface UpdateProduct {
	name: string;
	price: number;
	description: string;
	photoURL: string;
	//createdAt: any;
	updatedAt: any;
}

@Component
export default class ShoppingComponent extends Vue {
  @Prop()
	private msg!: string;
	private isSignin: boolean = false;
	private signinStatus = "signed out"

	private isActive = "1";
	
	private query_documents: Array<AddDocument> = new Array(0)

	private add_document: AddDocument = {id: "", product: {name: "塩大福", description: "美味しい塩大福", price: 0, photoURL: "塩大福1.jpg", createdAt: "", updatedAt: ""}};
	private update_document: UpdateDocument = {id: "", product: {name: "", description: "", price: 0, photoURL: ""/*, createdAt: ""*/, updatedAt: ""}};
	private update_index = -1
	private update_proc = ""
	private update_result = ""
	//private add_name = "name";
	//private add_description = "description";
	//private add_price = 0;
	//private add_photoURL = "http//";
	
	//private update_name = "name";
	//private update_description = "description";
	//private update_price = 0;
	//private update_photoURL = "http//";

	/** ライフサイクルフック */
	public created(){
		const user = this.$auth.currentUser;
		if (user) {
			// User is signed in.
			const email = user.email
			window.console.log("created() 1.email: " + email)
			if (email == "toru.watanabe11@gmail.com") {
				this.isSignin = true
				this.signinStatus = "signed in"
			} else {
				this.isSignin = false
				this.signinStatus = "signed out"
			}
		} else {
			// No user is signed in.
			this.isSignin = false
			this.signinStatus = "signed out"
		}
		// 「products」コレクションを読む	
		this.query_product()
	}


	private click_add(): void {
		window.console.log("click() 1.name: " + this.add_document.product.name)
		window.console.log("click() 2.price: " + this.add_document.product.price)
		window.console.log("click() 3.description: " + this.add_document.product.description)
		window.console.log("click() 4.photoURL: " + this.add_document.product.photoURL)
		//var message = ""
		if (this.add_document.product.name == "") {
			alert("nameが空白です")
			return
		}
		if (this.add_document.product.price == 0) {
			alert("priceが0です")
			return
		}
		if (this.add_document.product.description == "") {
			alert("descriptionが空白です")
			return
		}
		if (this.add_document.product.photoURL == "") {
			alert("photoURLが空白です")
			return
		}

		var message = "name: " + this.add_document.product.name
		message += "\nprice: " + this.add_document.product.price
		message += "\ndescription: " + this.add_document.product.description
		message += "\nphotoURL: " + this.add_document.product.photoURL
		message += "\n\nの内容で登録しますか？"
		const ans = confirm(message)
		if (ans) {
			this.addDocument()
			//alert("登録機能は未サポートです")
		}
	}

	private addDocument(): void {
		window.console.log("addDocumentd() 1." + this.$watanabe)
		/*
		var product: Product = {
			name:"塩大福3",
			s.add_document.product.name = this.query_documents[index].product.name
			description:"美味しい塩大福3",
			price: 120,
			photoURL:"http://www.hiroict.com/files/talkai/Pictures/トークA愛/塩大福1.jpg",
			createdAt: firebase.firestore.FieldValue.serverTimestamp(),
			updatedAt: firebase.firestore.FieldValue.serverTimestamp(),
		}
		*/
		this.add_document.product.createdAt = firebase.firestore.FieldValue.serverTimestamp(),
		this.add_document.product.updatedAt = firebase.firestore.FieldValue.serverTimestamp(),
		window.console.log("addDocumentd() 2.")
		//window.console.log("addDocumentd() 2.product.name: "+ product.name)
		//window.console.log("addDocumentd() 3.product.createdAt: "+ product.createdAt)
		const productsRef = this.$firestore.collection('products') // ①
		productsRef.add(this.add_document.product) // ②
		.then((docRef: any) => {
			window.console.log("addDocument() 4.Document written with ID: " + docRef.id) // ③
		})
		.catch((error: any) => {
			window.console.log("addDocument() 5.Error adding document: " + error)  // ④
		})
	}
	
	private click_buy(index: number): void {
		window.console.log("click_buy() 1.index: " + index)
		// TODO
	}

	private click_update(index: number): void {
		window.console.log("click_update() 1.index: " + index)
		window.console.log("click_update() 2.name: " + this.query_documents[index].product.name)
		this.update_index = index
		this.update_document.id = this.query_documents[index].id
		this.update_document.product.name = this.query_documents[index].product.name
		this.update_document.product.description = this.query_documents[index].product.description
		this.update_document.product.price = this.query_documents[index].product.price
		this.update_document.product.photoURL = this.query_documents[index].product.photoURL
	}

	private click_update2(): void {
		window.console.log("click_update2() 1.name: " + this.update_document.product.name)
		window.console.log("click_update2() 2.price: " + this.update_document.product.price)
		window.console.log("click_update2() 3.description: " + this.update_document.product.description)
		window.console.log("click_update2() 4.photoURL: " + this.update_document.product.photoURL)
		//var message = ""
		if (this.update_document.product.name == "") {
			alert("nameが空白です")
			return
		}
		if (this.update_document.product.price == 0) {
			alert("priceが0です")
			return
		}
		if (this.update_document.product.description == "") {
			alert("descriptionが空白です")
			return
		}
		if (this.update_document.product.photoURL == "") {
			alert("photoURLが空白です")
			return
		}

		var message = "name: " + this.update_document.product.name
		message += "\nprice: " + this.update_document.product.price
		message += "\ndescription: " + this.update_document.product.description
		message += "\nphotoURL: " + this.update_document.product.photoURL
		message += "\n\nの内容で登録しますか？"
		const ans = confirm(message)
		if (ans) {
			this.updateDocument()
			//alert("登録機能は未サポートです")
		}
	}

	private updateDocument(): void {
		window.console.log("updateDocument() 1.update_index; " + this.update_index)
		if (this.update_index < 0) {
			window.console.log("updateDocument() 2.更新できません。")
			this.update_proc = "更新できません。"
			return
		}
		/*
		if (this.update_document.product.createdAt == undefined || this.update_document.product.createdAt == "") {
			window.console.log("click_update() 2.createdAt: " + this.update_document.product.createdAt)
			this.update_document.product.createdAt = this.getStringFromDate(new Date())
			window.console.log("click_update() 3.createdAt: " + this.update_document.product.createdAt)
		}
		this.update_document.product.updatedAt = this.getStringFromDate(new Date())
		*/
		this.update_document.product.updatedAt = firebase.firestore.FieldValue.serverTimestamp()
		const documentsRef = this.$firestore.collection('products')
		documentsRef.doc(this.update_document.id).update(this.update_document.product)
		.then(() => {
			const message = "Document updated with ID: " + this.update_document.id
			this.update_result = message
			window.console.log("click_update() 4." + message)
		})
		.catch((error: any) => {
			window.console.log("click_update() 5.Error adding document: " + error)
		})
		this.update_proc = ""
		this.update_index = -1
		//*/
	}

	private query_product(): void {
		window.console.log("query_product() 1.")
		const contentsRef = this.$firestore.collection('products') // ①
		contentsRef
			// 「products」コレクションを読む
			.get().then((snapShot: any) => { // ②
				snapShot.forEach ((doc: any) => { // ③
					// ドキュメント単位に処理
					window.console.log("query_product() 2.doc.id: " + doc.id)
					var data = doc.data() // ④
					window.console.log("query_product() 3.data.name: " + data.name)
					//this.query_documents.id = doc.id
					window.console.log("query_product() 4.data.photoURL: " + data.photoURL)
					//var jpg = data.photoURL
					//var src = require("../assets/" + jpg)
					const photoURL = "https://firebasestorage.googleapis.com/v0/b/helloapp-87353.appspot.com/o/" + data.photoURL + "?alt=media"
					this.query_documents.push({id:doc.id, product: {name: data.name, price: data.price, description: data.description, photoURL: photoURL/*require("../assets/" + data.photoURL)*/, createdAt: data.createdAt.toDate(), updatedAt: data.updatedAt.toDate()}})
			})
		})
	}

	//日付から文字列に変換する関数
	private getStringFromDate(date: Date): string {
		//var today: Date = Date()
		var year_str = date.getFullYear();
		//月だけ+1すること
		var month_str = 1 + date.getMonth();
		var day_str = date.getDate();
		var hour_str = date.getHours();
		var minute_str = date.getMinutes();
		var second_str = date.getSeconds();

		var format_str = "YYYY-MM-DD hh:mm:ss";
		format_str = format_str.replace(/YYYY/g, year_str.toString());
		format_str = format_str.replace(/MM/g, month_str.toString());
		format_str = format_str.replace(/DD/g, day_str.toString());
		format_str = format_str.replace(/hh/g, hour_str.toString());
		format_str = format_str.replace(/mm/g, minute_str.toString());
		format_str = format_str.replace(/ss/g, second_str.toString());

		return format_str;
	}
	
  private pre1 = `
	public queryProc(id: string) {
		window.console.log("queryProc() 1.")
		const postsRef = this.$firestore.collection('posts')  // ①
		const post1 = postsRef.doc(id).get().then((doc: any) => { // ②
			if (doc.exists) {
				const post:Post = doc.data() // ③
				this.uid = post.uid
				this.title = post.title
				this.content = post.content
				this.createdAt = post.createdAt
				this.tags = post.tags
				this.image = post.image
			
				window.console.log("queryProc() 2." + post.title)
				return doc.data() as Post; // キャスト必要
			} else {
				window.console.log("queryProc() 3.No Document")
			}
		})
		window.console.log("queryProc() 4." + this.$watanabe)
	}`
  private pre2 = `
	var posts: Array<Post> = []
	
	public queryProc2() {
		window.console.log("queryProc2() 1.")
		const postsRef = this.$firestore.collection('posts') // ①
		postsRef.get().then((snapShot: any) => { // ②
			snapShot.forEach ((doc: any) => { // ③
				var data = doc.data() // ④
				var post: Post = {uid:data.uid, title:data.title, content:data.content, createdAt:data.createdAt, tags:data.tags, image:data.image}
				this.posts.push(post)
				this.firstPost()
				window.console.log("queryProc2() 2.posts: " + this.posts)
			})
		})
		window.console.log("queryProc2() 3." + this.$watanabe)
	}
	
	public firstPost() {
		this.postIndex = 0
		var post = this.posts[this.postIndex]
		this.uid = post.uid
		this.title = post.title
		this.content = post.content
		this.createdAt = post.createdAt
		this.tags = post.tags
		this.image = post.image
	}`
  private pre3 = `
	public addDocument() {
		window.console.log("addDocument() 1.")
		var post1: Post = {
			uid:"0001",
			title:"ダンスの練習",
			content:"トークAでダンスの練習を始めましょう",
			createdAt:"2020-11-6",
			tags:["Dance"],
			image:"http://www.hiroict.com/img/akiko/firestore_1.png"
		}
		const postsRef = this.$firestore.collection('posts') // ①
		postsRef.add(post1) // ②
		.then((docRef: any) => {
			window.console.log("addDocument() 2.Document written with ID: " + docRef.id) // ③
		})
		.catch((error: any) => {
			window.console.log("addDocument() 3.Error adding document: " + error)  // ④
		})
	}`
  private pre4 = `
	import firebase from 'firebase/app'
	import 'firebase/firestore'
	import 'firebase/auth'
	import config from './config'

	export default {
  	install(Vue: any, options: any) {
    	const firebaseApp = firebase.initializeApp(config)

	    // instance propertyの登録
	    Vue.prototype.$firestore = firebaseApp.firestore()
	    Vue.prototype.$auth = firebaseApp.auth()
	    Vue.prototype.$watanabe = 'watanabe'
	    window.console.log("index.ts install() 1.");
	    //window.console.log("index.ts install() 2." + this.$watanabe);

	  },
	};`

  private pre5 = `
	import Vue from 'vue'
	import App from './App.vue'
	import './registerServiceWorker'
	import router from './router'
	import store from './store'

	// ここから追加
	import firebase from './firebase' // 追記
	Vue.use(firebase) //追記
	window.console.log("main.ts 1.");
	// ここまで追加

	Vue.config.productionTip = false

	new Vue({
	  router,
	  store,
	  render: h => h(App)
	}).$mount('#app')`

  private pre6 = `
	import Vue from 'vue'
	import firebase from 'firebase/app'

	declare module 'vue/types/vue' {
	  interface Vue {
	    $auth: firebase.auth.Auth,
	    $firestore: firebase.firestore.Firestore
	    $watanabe: string,
	  }
	}`

  private pre7 = `
	navigator.mediaDevices = navigator.mediaDevices || ((navigator.mozGetUserMedia || navigator.webkitGetUserMedia) ? {
	   getUserMedia: function(c) {
	     return new Promise(function(y, n) {
	       (navigator.mozGetUserMedia ||
	        navigator.webkitGetUserMedia).call(navigator, c, y, n);
	     });
	   }
	} : null);

	if (!navigator.mediaDevices) {
	  console.log("getUserMedia() not supported.");
	  return;
	}

	// Prefer camera resolution nearest to 1280x720.

	var constraints = { audio: true, video: { width: 1280, height: 720 } };

	navigator.mediaDevices.getUserMedia(constraints)
	.then(function(stream) {
	  var video = document.querySelector('video');
	  video.srcObject = stream
	  video.onloadedmetadata = function(e) {
	    video.play();
	  };
	})
	.catch(function(err) {
	  console.log(err.name + ": " + err.message);
	});
	`
	
  private contents1: Description = {
  	id: "1",
  	title: "アプリケーション要件",
  	descriptions: [
  	 {id: "1",
  	  title: "「商品」ドキュメント",
  	  images: [
  	    { src: "",
  	  	  comment: "",
  	    },
  	  ],
  	  items: [
  	  	"コレクションは「products」とします。",
  	  	"「products」コレクションには、以下のフィールドを持ちます。",
  	  	"・「name」: 商品名",
  	  	"・「photoURL」: 写真",
  	  	"・「description」: 商品の説明",
  	  	"・「price」: 価格",
  	  	"・「status」: 在庫状態",
  	  	"・「stocks」: 在庫数",
  	  	"・「createdAt」: 作成日付",
  	  	"・「updatedAt」: 更新日付",
  	    ],
  	  pres: [],
  	 }, // end of id=1
  	 {id: "2",
  	  title: "ユーザ管理",
  	  images: [
  	    { src: "",
  	  	  comment: "",
  	    },
  	  ],
  	  items: [
  	  	"会員情報のコレクションは「users」とします。",
  	  	"公開プロフィールは「public-profiles」とします。",
  	  	"「users」と「public-profiles」のドキュメントIDは、Athenticationから払い出されるユーザIDを使用します。",
  	  	"「users」コレクションには、以下のフィールドを持ちます。",
  	  	"・「name」: 氏名",
  	  	"・「adress」: 住所",
  	  	"・「phoneNumber」: 電話番号",
  	  	"・「createdAt」: 作成日付",
  	  	"・「updatedAt」: 更新日付",
  	  	"「public-profiles」コレクションには、以下のフィールドを持ちます。",
  	  	"・「displayName」: 公開氏名",
  	  	"・「photoURL」: 写真",
  	  	"・「createdAt」: 作成日付",
  	  	"・「updatedAt」: 更新日付",
  	    ],
  	  pres: [],
  	 }, // end of id=1
  	]
  }
  private contents2: Description = {
  	id: "2",
  	title: "買い物かご",
  	descriptions: [
  	 {id: "1",
  	  title: "買い物かごの概要",
  	  images: [
  	    { src: "",
  	  	  comment: "",
  	    },
  	  ],
  	  items: [
  	  	"「Realtime Listener」機能を使用して最新のデータの同期を行います。",
  	    ],
	  pres: [],
  	 }, // end of id=1
  	 {id: "2",
  	  title: "買い物かごの中身の設計",
  	  images: [
  	    { src: "",
  	  	  comment: "",
  	    },
  	  ],
  	  items: [
  	  	"「買い物かごの中身」ドキュメントは「誰が」「どの商品を」「何個買うのか」と言う情報を管理します。",
  	  	"所有者の情報はドキュメント内に持たず、ユーザ管理ドキュメントのサブコレクション「/users/|uid|/items-in-cart/|item|」として扱います。",
  	  	"かごの中身ドキュメントは「誰が」「どの商品を」「何個買うのか」と言う情報を管理します。",
  	  	"かごの中身ドキュメントは「誰が」「どの商品を」「何個買うのか」と言う情報を管理します。",
  	    ],
	  pres: [],
  	 }, // end of id=2
  	 {id: "3",
  	  title: "買い物かごの中身の操作",
  	  images: [
  	    { src: "",
  	  	  comment: "",
  	    },
  	  ],
  	  items: [
  	  	"TODO",
  	    ],
	  pres: [],
  	 }, // end of id=3
  	]
  }
  private contents3: Description = {
  	id: "3",
  	title: "商品購入",
  	descriptions: [
  	 {id: "1",
  	  title: "商品購入の概要",
  	  images: [
  	    { src: "",
  	  	  comment: "",
  	    },
  	  ],
  	  items: [
  	  	"TODO",
  	    ],
	  pres: [],
  	 }, // end of id=1
  	 {id: "2",
  	  title: "処理方式の検討",
  	  images: [
  	    { src: "",
  	  	  comment: "",
  	    },
  	  ],
  	  items: [
  	  	"TODO",
  	    ],
	  pres: [],
  	 }, // end of id=2
  	 {id: "3",
  	  title: "注文処理を実装する",
  	  images: [
  	    { src: "",
  	  	  comment: "",
  	    },
  	  ],
  	  items: [
  	  	"TODO",
  	    ],
	  pres: [],
  	 }, // end of id=3

  	]
  }
  private contents4: Description = {
  	id: "4",
  	title: "レビュー機能",
  	descriptions: [
  	 {id: "1",
  	  title: "レビュー機能の概要",
  	  images: [
  	    { src: "",
  	  	  comment: "",
  	    },
  	  ],
  	  items: [
  	  	"TODO",
  	    ],
	  pres: [],
  	 }, // end of id=1
  	 {id: "2",
  	  title: "レビューの設計",
  	  images: [
  	    { src: "",
  	  	  comment: "",
  	    },
  	  ],
  	  items: [
  	  	"TODO",
  	    ],
	  pres: [],
  	 }, // end of id=2
  	 {id: "3",
  	  title: "「商品」の改修",
  	  images: [
  	    { src: "",
  	  	  comment: "",
  	    },
  	  ],
  	  items: [
  	  	"TODO",
  	    ],
	  pres: [],
  	 }, // end of id=3
  	 {id: "4",
  	  title: "レビューを投稿する",
  	  images: [
  	    { src: "",
  	  	  comment: "",
  	    },
  	  ],
  	  items: [
  	  	"TODO",
  	    ],
	  pres: [],
  	 }, // end of id=4
  	]
  }

  private contents5: Description = {
  	id: "5",
  	title: "e-社寺システム",
  	descriptions: [
  	 {id: "1",
  	  title: "WebRTC機能の利用",
  	  images: [
  	    { src: "",
  	  	  comment: "",
  	    },
  	  ],
  	  items: [
  	  	"API は主に以下の３つのモジュールから成ります。",
  	  	"・MediaStream (別名 getUserMedia)",
  	  	"→マイクとカメラに対するストリームアクセス",
  	  	"・RTCPeerConnection",
  	  	"→ブラウザ間の Audio/Video データストリーミング",
  	  	"・RTCDataChannel",
  	  	"→Audio/Video データストリーミング以外のデータ通信（例えばゲーミング、リモートデスクトップ、ファイル転送など）",
  	  	"e-社寺システムでは、マイクとカメラに対するストリームアクセスのため、上記のMediaStream機能を使用します。",
  	    ],
	  pres: [],
  	 }, // end of id=1
  	 {id: "2",
  	  title: "新しくなったMediaDevice.getUserMedia()について",
  	  images: [
  	    { src: "",
  	  	  comment: "",
  	    },
  	  ],
  	  items: [
  	  	"MediaDevice.getUserMedia()を使用するとWebカメラの動画とマイクにアクセスできるようになります。",
  	  	"新しくなったMediaDevice.getUserMedia()の主な変更点は、以下の通りです。",
  	  	"・旧navigator.getUserMedia() → 新navigator.mediaDevices.getUserMedia()",
  	  	"・ベンダープレフィクスが不要になった。",
  	  	"・コールバックではなくPromiseベースになった。",
  	    ],
	  pres: [{comment: "プログラミング例", src: this.pre7}],
  	 }, // end of id=2
  	 {id: "3",
  	  title: "「firebase」の利用",
  	  images: [
  	    { src: "",
  	  	  comment: "",
  	    },
  	  ],
  	  items: [
  	  	"MediaDevice.getUserMedia()は、Webサーバが「https://～」の形でないと実行されません。",
  	  	"そこで「firebase」の「Hosting」機能を使って、「https://～」の形の静的なWebサーバを構築します。",
  	  	"https://helloapp-87353.web.app/",
  	    ],
	  pres: [],
  	 }, // end of id=3
  	 {id: "4",
  	  title: "レビューを投稿する",
  	  images: [
  	    { src: "",
  	  	  comment: "",
  	    },
  	  ],
  	  items: [
  	  	"TODO",
  	    ],
	  pres: [],
  	 }, // end of id=4
  	]
  } // end of contents5
  
} // end of export

